import Cookies from 'js-cookie'

export function checkAuthorize(authorizeItem) {
  const auth = Cookies.get(authorizeItem);
  if(auth === 'false'){
    alert('權限不符')
    return false
  }
  return true

}



// WEBPACK FOOTER //
// ./src/asset/js/authorize.js